import apiClient from '../utils/apiClient';

/**
 * Cashier utilities: báo cáo và đối soát
 * Chi tiết luồng xem CASHIER_MANAGEMENT_GUIDE.md & CASHIER_TRACING_GUIDE.md
 */
export const cashierAPI = {
  /**
   * Báo cáo ca thu ngân
   */
  getCashierReport: async (shiftId) => {
    return await apiClient.get({
      url: `/shifts/${shiftId}/cashier-report`,
    });
  },

  /**
   * Danh sách ca cần đối soát
   */
  getPendingReconciliations: async (params = {}) => {
    return await apiClient.get({
      url: '/reconciliation/pending',
      params,
    });
  },

  /**
   * Chi tiết đối soát theo shift
   */
  getReconciliationDetail: async (shiftId) => {
    return await apiClient.get({
      url: `/reconciliation/${shiftId}`,
    });
  },

  /**
   * Đối soát & giải trình
   */
  reconcileShift: async (shiftId, data) => {
    return await apiClient.post({
      url: `/reconciliation/${shiftId}/reconcile`,
      data,
    });
  },

  /**
   * Thống kê chênh lệch
   */
  getReconciliationStats: async (params = {}) => {
    return await apiClient.get({
      url: '/reconciliation/statistics',
      params,
    });
  },
};


